import { Button } from '@purpur/library';
import styled, { css } from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

type ButtonProps = {
    $styledAsLink?: boolean;
    $withPadding?: boolean;
};

export const StyledButton = styled(Button)<ButtonProps>`
    ${({ $withPadding }) =>
        !$withPadding &&
        css`
            padding: 0;
        `}

    font-weight: ${getPurpurTypography('weightNormal')};
    font-size: inherit;

    ${({ $styledAsLink }) =>
        $styledAsLink &&
        css`
            text-decoration: underline;
            transition: background-color 0.15s ease-in-out;

            &:hover {
                background-color: ${getPurpurColor('backgroundInteractiveTransparentHover')};
            }
        `}
`;

export const DivStyledAsLink = styled.div`
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    gap: ${getPurpurSpacing('50')};
    text-decoration: underline;
    color: ${getPurpurColor('textInteractivePrimary')};
    transition: background-color 0.15s ease-in-out;
    font-size: inherit;

    &:hover {
        background-color: ${getPurpurColor('backgroundInteractiveTransparentHover')};
    }
`;
